const env = (import.meta as any).env

export default {
  STRATA47_MB_ENV: env.VITE_STRATA47_MB_ENV || 'test',
  STRATA47_API_URL: env.VITE_STRATA47_API_URL || 'https://test-api.strata47.com',
  STRATA47_BP_TOKEN: env.VITE_STRATA47_BP_TOKEN,
  AUTH0_AUDIENCE: env.VITE_STRATA47_AUTH0_AUDIENCE,
  AUTH0_ORG: env.VITE_STRATA47_AUTH0_ORG,
  AUTH0_DOMAIN: env.VITE_STRATA47_AUTH0_DOMAIN,
  AUTH0_CLIENT_ID: env.VITE_STRATA47_AUTH0_CLIENT_ID,
  STRATA47_OMNIIQ_API: env.VITE_STRATA47_OMNIIQ_API,
  STRATA47_ENABLE_REALTIME_FEATURES: env.VITE_STRATA47_ENABLE_REALTIME_FEATURES === 'true',
  STRATA47_USE_SERIAL_REGISTRATION: env.VITE_STRATA47_USE_SERIAL_REGISTRATION,
  STRATA47_DEFAULT_DEVICE_TYPE_ID: env.VITE_STRATA47_DEFAULT_DEVICE_TYPE_ID,
}